module.exports = __webpack_public_path__ + "toGroom-we-r-b.5e334c33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-we-r-b.jpg
// module id = vGxv
// module chunks = 0